import { z } from 'zod';
import { UserRoleSchema } from './enums.js';
/** 8..200 chars, any characters, compared as-is (no trimming, NFC-normalise only). */
export const PasswordSchema = z.string().min(8).max(200);
export const UsernameSchema = z
    .string()
    .trim()
    .min(1)
    .max(60)
    .transform((v) => v.toLowerCase());
export const DisplayNameSchema = z.string().trim().min(1).max(60);
export const LoginRequestSchema = z.object({
    username: z.string().trim().min(1).max(200),
    password: z.string().min(1).max(200),
});
export const PublicUserSchema = z.object({
    id: z.number().int(),
    username: z.string(),
    displayName: z.string(),
    role: UserRoleSchema,
    isActive: z.boolean(),
    createdAt: z.string(),
    /** Stable, never-reused identifier for this account - set once at creation, survives a rename or handover. */
    uuid: z.string(),
    /** Display form of `uuid`, e.g. "U-7F3A2C". */
    shortCode: z.string(),
});
export const MeResponseSchema = z.object({
    user: PublicUserSchema,
});
export const ChangePasswordRequestSchema = z.object({
    currentPassword: z.string().min(1).max(200),
    newPassword: PasswordSchema,
});
export const CreateUserRequestSchema = z.object({
    username: UsernameSchema,
    displayName: DisplayNameSchema,
    password: PasswordSchema,
    role: UserRoleSchema,
});
export const UpdateUserRequestSchema = z.object({
    displayName: DisplayNameSchema.optional(),
    /** Changing this signs the account out (deletes its sessions) - unlike a display-name-only change. */
    username: UsernameSchema.optional(),
    role: UserRoleSchema.optional(),
    isActive: z.boolean().optional(),
    password: PasswordSchema.optional(),
});
export const UserListResponseSchema = z.object({
    users: z.array(PublicUserSchema),
});
/** `POST /api/users/:id/handover` - hands an account to a new person without losing its identity. */
export const HandoverUserRequestSchema = z.object({
    displayName: DisplayNameSchema,
    username: UsernameSchema,
    password: PasswordSchema,
    note: z
        .string()
        .trim()
        .max(500)
        .optional()
        .transform((v) => (v === '' ? null : (v ?? null))),
});
export const UserHandoverSchema = z.object({
    id: z.number().int(),
    userId: z.number().int(),
    fromDisplayName: z.string(),
    fromUsername: z.string(),
    toDisplayName: z.string(),
    toUsername: z.string(),
    note: z.string().nullable(),
    at: z.string(),
    byUserId: z.number().int(),
});
export const UserHandoverListResponseSchema = z.object({
    handovers: z.array(UserHandoverSchema),
});
//# sourceMappingURL=users.js.map